import { useState } from "react";
import { useParams } from "react-router-dom";
import type { Article, Category } from "@core/features/support";
import { Type } from "@themes/pollinator/ui/Type";
import { SupportCategoryTreeCategoryItem } from "./SupportCategoryTreeCategoryItem";

export interface Props {
  activeArticleId?: string;
  categories: Category[];
  className?: string;
  onArticleClick?: (article: Article) => void;
}

export function SupportCategoryTree({
  activeArticleId,
  categories,
  className,
  onArticleClick,
}: Props) {
  const { articleId } = useParams();

  const articleIdToUse = activeArticleId || articleId;

  const currentArticleCategory = categories.find((category) =>
    category.articles
      .map((article) => article.id)
      .includes(articleIdToUse || "")
  );

  const [expandedCategories, setExpandedCategories] = useState<string[]>([
    currentArticleCategory?.id || "",
  ]);

  const toggleCategory = (categoryId: string) => {
    setExpandedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleCategoryClick = (category: Category) => {
    toggleCategory(category.id);
  };

  return (
    <nav className={className}>
      <Type variant="h4" className="mb-2 hidden md:block">
        Categories
      </Type>
      <ul className="space-y-1">
        {categories.map((category) => (
          <SupportCategoryTreeCategoryItem
            key={category.id}
            category={category}
            depth={0}
            hasChildren={
              category.subcategories.length > 0 || category.articles.length > 0
            }
            isExpanded={expandedCategories.includes(category.id)}
            onArticleClick={onArticleClick}
            onCategoryClick={handleCategoryClick}
          />
        ))}
      </ul>
    </nav>
  );
}

export default SupportCategoryTree;

